import { wpCustomFieldNames } from '@constants';
import { RootQueryToPostConnectionWhereArgsMetaArray } from '@/src/generated/graphql';

export const getHnaviCategoryMetaQuery = (
  category: string
): RootQueryToPostConnectionWhereArgsMetaArray => ({
  key: wpCustomFieldNames.hnaviMainCategory,
  value: category,
});
